import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import {DatePipe} from '@angular/common';
//import { Invoice } from '../../interfaces/invoice.interface'; 
import { CustomerCode } from '../../interfaces/customercode.interface';
import { Product } from '../../interfaces/product.interface';
import { Employee } from '../../interfaces/employee.interface';
import { WarehouseCode } from '../../interfaces/warehousecode.interface';
import { InvoiceService } from "../../services/invoice";
import { WarehousecodeService } from "../../services/warehousecode";
import { CustomerCodeService } from "../../services/customercode";
import { ProductcodeService } from "../../services/productcode";
import { EmployeeService } from '../../services/employee';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder  } from '@angular/forms';
import { Router } from '@angular/router';
import { Invoice } from '../../interfaces/invoice.interface';

@Component({
  selector: 'app-edit-invoice',
   imports: [ReactiveFormsModule, DatePipe],
  templateUrl: './edit-invoice.html',
  styleUrl: './edit-invoice.css'
})

export class EditInvoiceComponent implements OnInit {
myForm: FormGroup;
  customercodes: CustomerCode[] = [];
  //products: Product[] = [];
  employeecodes: Employee[] = [];
  warehousecodes: WarehouseCode[] = [];
  productcodes: Product[] = [];
  selectedInvoice: Invoice = {} as Invoice;

    constructor(private invoiceService: InvoiceService, 
              private warehousecodeService: WarehousecodeService,
              private customercodeService: CustomerCodeService,
              private productcodeService: ProductcodeService,
              private employeeService: EmployeeService,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                  id: new FormControl(''),
                  customercode: new FormControl('',[Validators.required,Validators.maxLength(30)]),
                  productcode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  employeecode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  shiptoaddressserial: new FormControl('',[Validators.pattern('^[0-9]*$')]),
                  invoiceno: new FormControl('',[Validators.required,Validators.maxLength(30)]),
                  invoicedate: new FormControl('',[Validators.required,Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  warehousecode: new FormControl('',[Validators.required,Validators.maxLength(25)]),
                  schemecode: new FormControl('',[Validators.maxLength(25)]),
                  volumesold: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  volumeid: new FormControl('',[Validators.required,Validators.maxLength(1)]),
                  grossturnover: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  cogs: new FormControl('',[Validators.required,Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  producttype: new FormControl('',[Validators.maxLength(1)]),
                  lineno: new FormControl('',[Validators.min(0),Validators.maxLength(8),Validators.pattern('[0-9]+')]),
                  customerpo: new FormControl('',[Validators.maxLength(100)]),
                  discount: new FormControl('',[Validators.min(0)]),
                  creationdate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  modifieddate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  netturnover: new FormControl('',[Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]),
                  supplierorderno: new FormControl('',[Validators.maxLength(30)]),
                  orderdate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  deliverynoteno: new FormControl('',[Validators.maxLength(30)]),
                  deliverynotedate: new FormControl('',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  retaildealerid: new FormControl('',[Validators.maxLength(20)]),
                  refinvoicenocredit: new FormControl('',[Validators.maxLength(30)]),
                  reflinenocreditnote: new FormControl('',[Validators.pattern('[0-9]+')]),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                });
              }


  async updateInvoice(): Promise<void> 
  {
    var id = this.myForm.value.id != null ? this.myForm.value.id : 0;
    var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";
    var productcode = this.myForm.value.productcode != null ? this.myForm.value.productcode.trim() : "";
    var employeecode = this.myForm.value.employeecode != null ? this.myForm.value.employeecode.trim() : "";
    var shiptoaddressserial = this.myForm.value.shiptoaddressserial != null ? this.myForm.value.shiptoaddressserial : null;
    var invoiceno = this.myForm.value.invoiceno != null ? this.myForm.value.invoiceno.trim() : "";
    var invoicedate = this.myForm.value.invoicedate != null ? this.myForm.value.invoicedate.trim() : "0000-00-00";
    var warehousecode = this.myForm.value.warehousecode != null ? this.myForm.value.warehousecode.trim() : "";
    var schemecode = this.myForm.value.schemecode != null ? this.myForm.value.schemecode.trim() : "";
    var volumesold = this.myForm.value.volumesold != null ? this.myForm.value.volumesold : null;
    var volumeid = this.myForm.value.volumeid != null ? this.myForm.value.volumeid.trim() : "";
    var grossturnover = this.myForm.value.grossturnover != null ? this.myForm.value.grossturnover : 0;
    var cogs = this.myForm.value.cogs != null ? this.myForm.value.cogs : 0;
    var producttype = this.myForm.value.producttype != null ? this.myForm.value.producttype.trim() : "";
    var lineno = this.myForm.value.lineno != null ? this.myForm.value.lineno : 0;
    var customerpo = this.myForm.value.customerpo != null ? this.myForm.value.customerpo.trim() : "";
    var discount = this.myForm.value.discount != null ? this.myForm.value.discount : 0;
    var creationdate = this.myForm.value.creationdate != null ? this.myForm.value.creationdate.trim() : "";
    var modifieddate = this.myForm.value.modifieddate != null ? this.myForm.value.modifieddate.trim() : "";
    var netturnover = this.myForm.value.netturnover != null ? this.myForm.value.netturnover : 0;
    var supplierorderno = this.myForm.value.supplierorderno != null ? this.myForm.value.supplierorderno.trim() : "";
    var orderdate = this.myForm.value.orderdate != null ? this.myForm.value.orderdate.trim() : "";
    var deliverynoteno = this.myForm.value.deliverynoteno != null ? this.myForm.value.deliverynoteno.trim() : "";
    var deliverynotedate = this.myForm.value.deliverynotedate != null ? this.myForm.value.deliverynotedate.trim() : "";
    var retaildealerid = this.myForm.value.retaildealerid != null ? this.myForm.value.retaildealerid.trim() : "";
    var refinvoicenocredit = this.myForm.value.refinvoicenocredit != null ? this.myForm.value.refinvoicenocredit.trim() : "";
    var reflinenocreditnote = this.myForm.value.reflinenocreditnote != null ? this.myForm.value.reflinenocreditnote : 0;
    var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";

    if (this.myForm.invalid && this.myForm.touched)
    {
      return;
    }

try
        {
          await this.invoiceService.updateInvoice(id,customercode,productcode,employeecode,shiptoaddressserial,invoiceno,invoicedate,warehousecode,schemecode,volumesold,volumeid,grossturnover,cogs,producttype,lineno,customerpo,discount,creationdate,modifieddate,netturnover,supplierorderno,orderdate,deliverynoteno,deliverynotedate,retaildealerid,refinvoicenocredit,reflinenocreditnote,uploaded);
          this.cdr.detectChanges();
          this.router.navigateByUrl('invoice'); 
        } catch (error) {
          console.error('createinvoice',error);
        }

    }


get id() {
    return this.myForm.get('id');
}
get customercode() {
    return this.myForm.get('customercode');
  }

  get productcode() {
    return this.myForm.get('productcode');
  }

  get employeecode() {
    return this.myForm.get('employeecode');
  }

  get shipotoaddressserial() {
    return this.myForm.get('shipotoaddressserial');
  }
  get invoiceno() {
    return this.myForm.get('invoiceno');
  }
  get invoicedate() {
    return this.myForm.get('invoicedate');
  }
  get warehousecode() {
    return this.myForm.get('warehousecode');
  }
  get schemecode() {
    return this.myForm.get('schemecode');
  }
  get volumesold() {
    return this.myForm.get('volumesold');
  }
  get volumeid() {
    return this.myForm.get('volumeid');
  }
  get grossturnover() {
    return this.myForm.get('grossturnover');
  }
  get cogs() {
    return this.myForm.get('cogs');
  }
  get producttype() {
    return this.myForm.get('producttype');
  }
  get lineno() {
    return this.myForm.get('lineno');
  }
  get customerpo() {
    return this.myForm.get('customerpo');
  }
  get discount() {
    return this.myForm.get('discount');
  }
  get creationdate() {
    return this.myForm.get('creationdate');
  }
  get modifieddate() {
    return this.myForm.get('modifieddate');
  }
  get netturnover() {
    return this.myForm.get('netturnover');
  }
  get supplierorderno() {
    return this.myForm.get('supplierorderno');
  }
  get orderdate() {
    return this.myForm.get('orderdate');
  }
  get deliverynoteno() {
    return this.myForm.get('deliverynoteno');
  }
  get deliverynotedate() {
    return this.myForm.get('deliverynotedate');
  }
  get retaildealerid() {
    return this.myForm.get('retaildealerid');
  }
  get refinvoicenocredit() {
    return this.myForm.get('refinvoicenocredit');
  }
  get reflinenocreditnote() {
    return this.myForm.get('reflinenocreditnote');
  }
  get uploaded() {  
    return this.myForm.get('uploaded');
  }

 async ngOnInit(): Promise<void> 
  {
        if (typeof this.invoiceService.selectedInvoice === undefined || this.invoiceService.selectedInvoice.id === undefined)
        {
          this.router.navigateByUrl('invoice'); ;
          return;
        }
    try 
    {
      this.warehousecodes = await this.warehousecodeService.getWarehousecodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getwarehousecodes',error);
    }

    try 
    {
      this.customercodes = await this.customercodeService.getCustomercodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getcustomercodes',error);
    }

    try 
    {
      this.productcodes = await this.productcodeService.getProductcodes();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getproductcodes',error);
    }

    try 
    {
      this.employeecodes = await this.employeeService.getEmployees();
      this.cdr.detectChanges();
    } catch (error) {
      console.error('getEmployees',error);
    }

      this.selectedInvoice = this.invoiceService.selectedInvoice;
      //this.myForm.value.customercode = this.customerService.selectedCustomer.customercode;
      this.myForm.get('id')?.setValue(this.invoiceService.selectedInvoice.id);
      this.myForm.get('customercode')?.setValue(this.invoiceService.selectedInvoice.customercode);
      this.myForm.get('productcode')?.setValue(this.invoiceService.selectedInvoice.productcode);
      this.myForm.get('employeecode')?.setValue(this.invoiceService.selectedInvoice.employeecode);
      this.myForm.get('shiptoaddressserial')?.setValue(this.invoiceService.selectedInvoice.shiptoaddressserial);
      this.myForm.get('invoiceno')?.setValue(this.invoiceService.selectedInvoice.invoiceno);
      this.myForm.get('invoicedate')?.setValue(this.invoiceService.selectedInvoice.invoicedate);
      this.myForm.get('warehousecode')?.setValue(this.invoiceService.selectedInvoice.warehousecode);
      this.myForm.get('schemecode')?.setValue(this.invoiceService.selectedInvoice.schemecode);
      this.myForm.get('volumesold')?.setValue(this.invoiceService.selectedInvoice.volumesold);
      this.myForm.get('volumeid')?.setValue(this.invoiceService.selectedInvoice.volumeid);
      this.myForm.get('grossturnover')?.setValue(this.invoiceService.selectedInvoice.grossturnover);
      this.myForm.get('cogs')?.setValue(this.invoiceService.selectedInvoice.cogs);
      this.myForm.get('producttype')?.setValue(this.invoiceService.selectedInvoice.producttype);
      this.myForm.get('lineno')?.setValue(this.invoiceService.selectedInvoice.lineno);
      this.myForm.get('customerpo')?.setValue(this.invoiceService.selectedInvoice.customerpo);
      this.myForm.get('discount')?.setValue(this.invoiceService.selectedInvoice.discount);
      this.myForm.get('creationdate')?.setValue(this.invoiceService.selectedInvoice.creationdate);
      this.myForm.get('modifieddate')?.setValue(this.invoiceService.selectedInvoice.modifieddate);
      this.myForm.get('netturnover')?.setValue(this.invoiceService.selectedInvoice.netturnover);
      this.myForm.get('supplierorderno')?.setValue(this.invoiceService.selectedInvoice.supplierorderno);
      this.myForm.get('orderdate')?.setValue(this.invoiceService.selectedInvoice.orderdate);
      this.myForm.get('deliverynoteno')?.setValue(this.invoiceService.selectedInvoice.deliverynoteno);
      this.myForm.get('deliverynotedate')?.setValue(this.invoiceService.selectedInvoice.deliverynotedate);
      this.myForm.get('retaildealerid')?.setValue(this.invoiceService.selectedInvoice.retaildealerid);
      this.myForm.get('refinvoicenocredit')?.setValue(this.invoiceService.selectedInvoice.refinvoicenocredit);
      this.myForm.get('reflinenocreditnote')?.setValue(this.invoiceService.selectedInvoice.reflinenocreditnote);
      this.myForm.get('uploaded')?.setValue(this.invoiceService.selectedInvoice.uploaded);
      this.cdr.detectChanges();

  }

  goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('invoice');
  }

}
